import React, { useEffect, useState } from 'react'
import { Image } from 'antd-mobile'
import { utils, apis } from '@/utils'
import styles from './Nav2.module.less'
import { RightOutline } from 'antd-mobile-icons'
import { useNavigate } from 'react-router-dom'
import { routesMap } from '@/router/routes'
import { ModuleItemProps } from '@/types/interfaces'
import { t } from '@/utils/i18n'
import iconNav from '@/assets/img/icon/nav-icon.png'
import hotImg from './hot.svg'

const { to } = utils
const { corpApi } = apis
const { px2rem, capitalizeFirstLetter, concatenateImageUrl } = utils

interface ModuleProps {
  module: ModuleItemProps
}

interface ModuleDetails {
  [key: string]: any
}

const Nav2: React.FC<ModuleProps> = (props) => {
  const { corpId, corpModuleId, moduleName } = props.module
  const navigate = useNavigate()
  const [detail, setDetail] = useState<ModuleDetails[]>([])
  const [navDetail, setNavDetail] = useState<ModuleDetails[]>([])
  /*
   * 获取模块详情
   */
  async function getModuleDetail() {
    if (!corpId || !corpModuleId) return

    // 获取详情
    const [err, res] = await to(
      corpApi.queryHomeModuleDetail({ corpId, corpModuleId }),
    )

    if (err || !res.data) return

    // 处理数据
    const detail = res.data.map((item: any) => {
      // 拼oss地址
      item.image = item.image ? concatenateImageUrl(item.image) : ''
      return item
    })

    const navDetail = detail.slice(0, 8)

    setDetail(detail)
    setNavDetail(navDetail)
  }
  /*
   * 点击跳转
   */
  function handleNavigation(index: number) {
    const item = navDetail[index]
    if (
      !item ||
      !item.detail ||
      !item.detail.dataType ||
      !item.detail.dataValue
    ) {
      return
    }

    const { dataType, dataValue, sort } = item.detail
    // 如果是货品，则跳到货品详情页
    // if (dataType === 6) {
    //   navigate(`/product/detail/${dataValue}`);
    //   return;
    // }

    // 否则跳到 筛选结果
    navigate(
      `${routesMap.MarktingSearch}?dataType=${dataType}&dataValue=${dataValue}&sort=${sort}`,
    )
  }

  const NavItem = () => {
    return navDetail.map((item: ModuleDetails, index: number) => {
      return (
        <div
          className={styles['nav-item']}
          onClick={() => handleNavigation(index)}
          key={corpModuleId + index}
        >
          <div className={styles['img-wrap']}>
            <Image
              fit="cover"
              className={
                item.image ? styles['preview-img'] : styles['nav-img-icon']
              }
              src={item.image || iconNav}
              lazy={true}
            ></Image>
          </div>
          <p className={styles['title'] + ' ep-2'}>
            {capitalizeFirstLetter(item.title)}
          </p>
        </div>
      )
    })
  }

  useEffect(() => {
    getModuleDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props])

  return (
    <div className={styles['nav-wrap']}>
      <div className={styles['hd']}>
        <div className={styles['nav-title']}>
          <img className={styles['nav-title-icon']} src={hotImg} />

          <span>{capitalizeFirstLetter(moduleName)}</span>
        </div>

        {detail.length > 8 && (
          <span
            className={styles['more']}
            onClick={() =>
              navigate(
                routesMap.MarktingNavs +
                  `?corpId=${corpId}&corpModuleId=${corpModuleId}`,
              )
            }
          >
            {t('更多')}
            <RightOutline fontSize={px2rem(28)} />
          </span>
        )}
      </div>
      <div className={styles['bd']}>
        <NavItem />
      </div>
    </div>
  )
}

export default Nav2
